"use client";

import Link from "next/link";
import { useCallback, useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { HOMEPAGE_COPY } from "@/lib/homepage/copy";

export default function HomepageFaqSection() {
  const { heading, items, viewAllLabel, viewAllHref } = HOMEPAGE_COPY.faq;
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  const toggleFaq = useCallback((index: number) => {
    setOpenFaqIndex((current) => (current === index ? null : index));
  }, []);

  return (
    <section className="w-full max-w-7xl mb-16" id="faqs">
      <h2 className="text-3xl md:text-4xl font-semibold text-center mb-8">
        {heading}
      </h2>
      <div className="space-y-4 max-w-3xl mx-auto">
        {items.map((faq, index) => {
          const isOpen = openFaqIndex === index;
          return (
            <div
              key={faq.id}
              className="border border-border rounded-lg overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggleFaq(index)}
                aria-expanded={isOpen}
                className="w-full flex justify-between items-center p-4 text-left bg-surface hover:bg-secondary transition"
              >
                <span className="font-medium pr-3">{faq.question}</span>
                <ChevronDownIcon
                  className={`h-5 w-5 text-text-light shrink-0 transition-transform ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                className={`px-4 overflow-hidden transition-all duration-300 ease-in-out ${
                  isOpen ? "max-h-[40rem] py-4" : "max-h-0"
                }`}
              >
                <p className="text-text-light">{faq.answer}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 text-center">
        <Link
          href={viewAllHref}
          className="text-primary hover:underline font-medium"
        >
          {viewAllLabel}
        </Link>
      </div>
    </section>
  );
}
